import { useEffect, useState } from 'react';
import { fetchCurrenciesList } from '../services/cdn';

export type ICurrencyListEntry = {
    name: string,
    longName: string,
    pluralName: string,
    symbol: string;
    colors: {
        primary: string;
        secondary?: string;
        gradient: string;
    }
}

export type ICurrencyList = {
    [key in string]: ICurrencyListEntry
}

export const useCurrencies = (): ICurrencyList => {
    const [result, setResult] = useState<ICurrencyList>({})
    useEffect(() => {
        fetchCurrenciesList()
            .then((data) => {
                setResult(data)
            })
            .catch(error => console.error(error))
    }, []);

    return result;
}